export const swallowException = () => {
    // Swallowing exception
};
